module.exports = __webpack_public_path__ + "img/lock-safe-circle.ddb4b9df.svg";